<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" :style="blockStyle">
        <div class="categories w-100" v-if="block.groupEnabled">
            <div class="category" v-for="(group, groupIndex) in boundItemList" :key="`list-item-category-${groupIndex}`">
                <cms-block-list-category :item="group.items[0]" :id-suffix="groupIndex" @block-selected="selectBlock" :block="categoryBlock" :parent="block"
                                         :editable="editable" :block-selection="blockSelection"/>

                <div class="category-items list-container">
                    <cms-block-renderer v-for="(item, index) in group.items" :key="`list-item-${item.id}`" :id-suffix="`${groupIndex}-${index}`" class="cms-list-item" no-body
                                        @block-selected="selectBlock" :block-component="bodyComponent" :item="item"
                                        :block="listItemBlock" :parent="block" :editable="editable && index === 0" :block-selection="index === 0 ? blockSelection : null"/>
                </div>
            </div>
        </div>
        <div class="list-container" v-else>
            <cms-block-renderer v-for="(item, index) in boundItemList" :key="`list-item-${item.id}`" :id-suffix="index" class="cms-list-item" no-body
                                @block-selected="selectBlock" :block-component="bodyComponent" :item="item"
                                 :block="listItemBlock" :parent="block" :editable="editable && index === 0" :block-selection="blockSelection"/>
        </div>
    </cms-block>
</template>

<script>
import CmsBlockListCategory from "@/components/editor/rendering/blocks/cms-block-list-category.vue";
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

// cms-block-list #hot-reload-debug
export default {
    name: `cms-block-list`,
    components: {
        CmsBlockListCategory,
        CmsBlockRenderer,
        CmsBlock
    },
    extends: CmsBlock,
    computed: {
        listItemBlock() {
            return this.block.children[0];
        },
        categoryBlock() {
            return this.block.children[1];
        },
        bodyComponent() {
            if (this.block.mediaProxy.layout === `cards`) {
                return `b-card`;
            } else {
                return `div`;
            }
        },
        blockStyle() {
            let style = {
                "--list-item-spacing": this.block.mediaProxy.spacing,
                "--list-item-columns": this.block.mediaProxy.columns
            }
            if (this.block.divider.active) {
                style[`--divider-width`] = this.block.divider.width;
                style[`--divider-color`] = this.block.divider.color;
            }
            return style;
        },
        boundItemList() {
            let list = [];
            if (this.block.itemType === `inherit`) {
                list = this.cms.getItemsByType(this.cmsPage.itemType);
            } else {
                list = this.cms.getItemsByType(this.block.itemType);
            }

            if (this.$route.query.filters) {
                // Note that all filters must be encoded in one queryParam
                // Ex: http://localhost:2050/search?filters=ownerId%3D69d419161ff582176e625172
                const query = decodeURIComponent(this.$route.query.filters);
                const filters = Object.fromEntries(new URLSearchParams(query));
                list = list.filter(cmsItem => {
                    for (let key in filters) {
                        console.log(key);
                        if (cmsItem.getNestedValue(key) !== filters[key])
                            return false;
                    }
                    return true;
                });
            }

            if (this.block.sortEnabled) {
                list.sort((a, b) => {
                    let fieldA = a[this.block.sortBy];
                    let fieldB = b[this.block.sortBy];

                    if (typeof fieldA === `object`) {
                        return this.$tr(fieldA).localeCompare(this.$tr(fieldB));
                    } else if (typeof fieldA === `string`) {
                        return fieldA.localeCompare(fieldB);
                    } else {
                        return fieldB - fieldA;
                    }
                });
                if (this.block.sortOrder === `desc`) {
                    list.reverse();
                }
            }

            if (this.block.groupEnabled) {
                const groups = list.reduce((groups, item) => {
                    const key = item.getFieldFormatted(this.block.groupBy);
                    if (!groups[key]) {
                        groups[key] = {
                            key: key,
                            items: []
                        };
                    }
                    groups[key].items.push(item);
                    return groups;
                }, {});
                list = [];
                for (let key in groups) {
                    list.push(groups[key]);
                }

                list.sort((a, b) => {
                    return a.key - b.key;
                });
                if (this.block.groupOrder === `desc`) {
                    list.reverse();
                }
            }

            return list;
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-cms-list {
    --divider-width: 0;
    --divider-color: 0;
    --list-item-columns: 0;
    --list-item-spacing: 10px;

    ::v-deep .cms-block {
        //margin-bottom: var(--list-item-spacing);
        break-inside:avoid;
        display: block;
    }

    .cms-list-item {
        width: 100%;
    }

    &.layout-default {
        ::v-deep .cms-block:not(:last-child):not(.cms-block-list-category) {
            border-bottom: var(--divider-width) solid var(--divider-color);
        }
    }

    .list-container {
        width: 100%;
    }

    //&.layout-cards {
    //    ::v-deep > .cms-container {
    //        display: block;
    //        column-count: var(--list-item-columns);
    //        column-gap: var(--list-item-spacing);
    //        orphans: 1;
    //        widows: 1;
    //        line-height: 1;
    //    }
    //}

    &.layout-cards {
        .list-container {
            padding-top: var(--list-item-spacing);
            padding-bottom: var(--list-item-spacing);
            display: grid;
            grid-template-columns: repeat(var(--list-item-columns), 1fr);
            grid-gap: var(--list-item-spacing);
        }
    }
}
</style>
